import type { AnyFilter } from '../../../shared/organizationPackages/filters';

import { initialState } from './reducer';
import type { PackageInventoryStore } from './types';

/**
 * Helper used for setting the filters in the packageInventory redux store.
 * Filters are set when a user changes them, but are also set when hydrating
 * the state on the initial page load.
 *
 * @param {PackageInventoryStore} draftState
 * @param {AnyFilter} [filter]
 */
export function setFilters(draftState: PackageInventoryStore, filter?: AnyFilter): void {
  if (!filter) {
    draftState.filter = initialState.filter;
    //  Early return so that we know filter is not undefined for the rest of the function.
    return;
  }

  //  Package filters
  if (filter.fetchers?.length) {
    draftState.filter.fetchers = filter.fetchers;
  } else {
    draftState.filter.fetchers = initialState.filter.fetchers;
  }

  if (filter.packageLabels?.length) {
    draftState.filter.packageLabels = filter.packageLabels;
  } else {
    draftState.filter.packageLabels = initialState.filter.packageLabels;
  }

  if (filter.packageName) {
    draftState.filter.packageName = filter.packageName;
  } else {
    draftState.filter.packageName = initialState.filter.packageName;
  }

  if (filter.locators?.length) {
    draftState.filter.locators = filter.locators;
  } else {
    draftState.filter.locators = initialState.filter.locators;
  }

  //  Project filters:
  if (filter.depth?.length) {
    draftState.filter.depth = filter.depth;
  } else {
    draftState.filter.depth = initialState.filter.depth;
  }

  if (filter.labels?.length) {
    draftState.filter.labels = filter.labels;
  } else {
    draftState.filter.labels = initialState.filter.labels;
  }

  if (filter.projectName) {
    draftState.filter.projectName = filter.projectName;
  } else {
    draftState.filter.projectName = initialState.filter.projectName;
  }

  if (filter.sources?.length) {
    draftState.filter.sources = filter.sources;
  } else {
    draftState.filter.sources = initialState.filter.sources;
  }

  if (filter.visibility?.length) {
    draftState.filter.visibility = filter.visibility;
  } else {
    draftState.filter.visibility = initialState.filter.visibility;
  }

  if (filter.blockTypes?.length) {
    draftState.filter.blockTypes = filter.blockTypes;
  } else {
    draftState.filter.blockTypes = initialState.filter.blockTypes;
  }

  //  Vuln filters:
  if (filter.cve) {
    draftState.filter.cve = filter.cve;
  } else {
    draftState.filter.cve = initialState.filter.cve;
  }

  if (filter.cwes) {
    draftState.filter.cwes = filter.cwes;
  } else {
    draftState.filter.cwes = initialState.filter.cwes;
  }

  if (filter.fixTypes?.length) {
    draftState.filter.fixTypes = filter.fixTypes;
  } else {
    draftState.filter.fixTypes = initialState.filter.fixTypes;
  }

  if (filter.severities?.length) {
    draftState.filter.severities = filter.severities;
  } else {
    draftState.filter.severities = initialState.filter.severities;
  }
}
